var PortafoliosDataGrid;
(function (PortafoliosDataGrid) {
    class ReorderGridColumns {
        constructor(_dotNetObj, _containerId) {
            this.dotNetObject = null;
            this.containerId = null;
            this.draggingColumnId = -1;
            this.dotNetObject = _dotNetObj;
            this.containerId = _containerId;
        }
        getResizeGridColumnsInstance() {
            return PortafoliosDataGrid.ResizeGridColumns.CurrentInstances.filter(a => a.containerId == this.containerId)[0];
        }
        setDotNetObj(_dotNetObj, _containerId) {
            if (this.dotNetObject)
                delete this.dotNetObject;
            this.containerId = _containerId;
            this.dotNetObject = _dotNetObj;
        }
        handleOnDragStart(_e, _columnId) {
            if (this.getResizeGridColumnsInstance().isResizing)
                return false;
            this.draggingColumnId = _columnId;
        }
        handleOnDrop(_e, _columnId) {
            if (this.getResizeGridColumnsInstance().isResizing)
                return false;
            this.dotNetObject.invokeMethodAsync('CambiarOrdenColumnas', this.draggingColumnId, parseInt(_columnId));
        }
        handleOnDragOver(_e, _columnId) {
            if (this.getResizeGridColumnsInstance().isResizing)
                return false;
            if (this.draggingColumnId != _columnId) {
                _e.preventDefault();
            }
        }
        static getInstance(_containerId) {
            return ReorderGridColumns.CurrentInstances.filter(a => a.containerId == _containerId)[0];
        }
        static crearInstancia(_dotNetObj, _containerId) {
            let htmlEl = document.getElementById(_containerId);
            if (!htmlEl) {
                return;
            }
            let found = ReorderGridColumns.CurrentInstances.filter(a => a.containerId == _containerId);
            if (found.length > 0) {
                let arrIndex = ReorderGridColumns.CurrentInstances.indexOf(found[0]);
                delete found[0];
                PortafoliosDataGrid.GridHeight.CurrentInstances.splice(arrIndex, 1);
            }
            let newInstance = new ReorderGridColumns(_dotNetObj, _containerId);
            ReorderGridColumns.CurrentInstances.push(newInstance);
            return newInstance;
        }
    }
    ReorderGridColumns.CurrentInstances = [];
    PortafoliosDataGrid.ReorderGridColumns = ReorderGridColumns;
})(PortafoliosDataGrid || (PortafoliosDataGrid = {}));
